import { render, staticRenderFns } from "./bdLayout.vue?vue&type=template&id=7f7735c2&"
import script from "./bdLayout.vue?vue&type=script&lang=js&"
export * from "./bdLayout.vue?vue&type=script&lang=js&"
import style0 from "./bdLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports